import { PropertiesTabsComponent } from './properties-tabs.component'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { SharedModule } from '@shared/shared.module'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'

@NgModule({
  declarations: [PropertiesTabsComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    TranslateModule,
    ContentEditableModule,
    SharedModule,
    RouterModule,
  ],
  exports: [PropertiesTabsComponent],
})
export class PropertiesTabsModule {}
